const routes = {
  signin: '/signin',
  ideas: '/ideas',
  newIdea: '/ideas/new',
  idea: '/ideas/:ideaId'
}

export default routes
